import React from 'react';
import { GetApp, Add, CloseSharp, RateReview, Settings, Refresh, ContentCopy, Search as SearchIcon, NotInterested as NotInterestedIcon } from '@mui/icons-material';
import ButtonComponent from '../../../component/button/button.component';
import CardFrom, { CardFormConfig } from '../../../component/card/card-from';
import i18n from '../../../i18n';
import { RestaurantInfoState } from './restaurant-info-state';
import { observer } from 'mobx-react-lite';
import { TableRowFeatures } from '../../../component/table/table.component';
import GlobalNotification from '../../../component/common/snackbar';
import moment from 'moment';
import { Box, Button, Grid, InputAdornment, Skeleton, Typography } from '@mui/material';
import StatusCheckLabel from '../../../component/status-check-label';
import copy from 'copy-to-clipboard';
import { CoreFileLog, FiskalyClientInfo, GybDevice, SecretKey, Staff } from '../../../models';
import CardView from '../../../component/card/card-view';
import AsyncCheckboxWithLoading from '../../../component/async-checkbox-with-loading';
import { useTranslation } from 'react-i18next';
import { accountState } from '../../my-account/account-state';
import { LoadGoogleMap } from '../../my-restaurant/map/google-maps-provider';
import { COUNTRY_REG_CITY_REGULAR, COUNTRY_REG_NAME_REGULAR, COUNTRY_REG_POSTCODE_REGULAR, COUNTRY_VAT_REGULAR } from '../../../constants/regular.constant';
import { isVerifactuArea, SPAIN_CITY_AREA } from '../../../constants/spain-city-area';
import CommonInput from '../../../component/form/common-input.component';
import { getQopEfrTunnelHost } from '../../../constants/tool.fn';
import {
    shouldShowFiskalyActivityCodeColumn,
    shouldShowFiskalySignInfoList,
} from './fiskaly-sign-info-table';

export const RestaurantInfoCardConfig: CardFormConfig[] = [
    // 主要信息数据
    {
        key: 'main',
        title: 'restaurant_info_page_text_main_information',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                comType: 'AVATAR',
                key: 'avatar',
                xs: 12
            },
            {
                key: 'country_code',
                label: 'restaurant_Country_and_Region',
                required: true,
                inputType: 'FLAG_INPUT',
                comType: 'INPUT',
                xs: 4
            },
            {
                key: 'nickname',
                label: 'restaurant_info_page_text_restaurant_name',
                required: true,
                regularType: 'inputLimit120',
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 8
            },
            {
                key: 'ex_string_id',
                label: 'restaurant_page_ex_string_id',
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6
            },
            {
                key: 'setting_restaurant_operating_status',
                label: 'restaurant_info_page_status',
                inputType: 'SELECT',
                comType: 'INPUT',
                xs: 6,
                items: [
                    {
                        value: '1',
                        label: 'restaurant_info_page_restaurant_open'
                    },
                    {
                        value: '2',
                        label: 'restaurant_info_page_restaurant_close'
                    },
                    {
                        value: '3',
                        label: 'restaurant_page_text_restaurant_change_ditta'
                    },
                    {
                        value: '4',
                        label: 'restaurant_info_page_restaurant_transfer'
                    },
                    {
                        value: '5',
                        label: 'restaurant_info_page_restaurant_pause'
                    },
                    {
                        value: '6',
                        label: 'restaurant_info_page_restaurant_changed_system'
                    },
                    {
                        value: '7',
                        label: 'restaurant_info_page_restaurant_sosreso'
                    },
                    {
                        value: '8',
                        label: 'restaurant_info_page_restaurant_annullato'
                    }
                ],
            },
            {
                key: 'description',
                label: 'restaurant_info_page_text_description',
                inputType: 'INPUT',
                comType: 'INPUT',
                multiline: true,
                multiRowsNumber: 3,
                xs: 12
            },
            {
                key: 'belonged_group',
                label: 'general_text_belonged_group',
                required: true,
                inputType: 'SELECT',
                comType: 'INPUT',
                xs: 12
            },
            {
                key: 'time_zone',
                label: 'restaurant_info_page_text_time_zone',
                inputType: 'SELECT',
                comType: 'INPUT',
                xs: 12
            }, {
                key: 'restaurant_version',
                label: 'restaurant_page_input_text_restaurant_version_source',
                inputType: 'SELECT',
                comType: 'INPUT',
                xs: 12
            },
        ]
    },
    // 联系方式&客户销售信息
    {
        key: 'contact&customer_sale_information',
        title: '',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        subCardConfig: [
            // 联系方式
            {
                key: 'contact',
                title: 'restaurant_info_page_text_contact',
                rowSpacing: 6,
                columnSpacing: { md: 4, xs: 4 },
                children: [{
                    key: 'restaurant_contact_person',
                    label: 'restaurant_info_page_text_contact_person',
                    inputType: 'INPUT',
                    comType: 'INPUT',
                    xs: 12,
                    md: 12
                },
                {
                    key: 'email',
                    label: 'general_text_email',
                    inputType: 'INPUT',
                    comType: 'INPUT',
                    regularType: 'email',
                    xs: 12,
                    md: 12
                },
                {
                    key: 'tel_prefix',
                    label: 'general_text_country_code',
                    inputType: 'COUNTRY_SELECT',
                    comType: 'INPUT',
                    xs: 2,
                    md: 2
                },
                {
                    key: 'tel',
                    label: 'restaurant_info_page_text_phone',
                    inputType: 'INPUT',
                    comType: 'INPUT',
                    required: true,
                    regularType: 'phone',
                    xs: 10,
                    md: 10
                },
                {
                    key: 'website',
                    label: 'restaurant_info_page_text_website',
                    inputType: 'INPUT',
                    comType: 'INPUT',
                    xs: 12,
                    md: 12
                },

                ]
            },
            // 客户销售信息
            {
                key: 'customer_sale_information',
                title: 'restaurant_info_page_text_customer_sales_information',
                rowSpacing: 6,
                columnSpacing: { md: 4, xs: 4 },
                children: [
                    {
                        key: 'belonged_reseller',
                        label: 'reseller_page_text_reseller',
                        inputType: 'SELECT' as const,
                        comType: 'INPUT',
                        xs: 12,
                        md: 6
                    },
                    {
                        key: 'business_labels',
                        label: 'restaurant_info_page_text_service_instance_tag',
                        inputType: 'SELECT_MUL' as const,
                        comType: 'INPUT',
                        xs: 12,
                        md: 6
                    },
                    {
                        key: 'authorization_type',
                        label: 'restaurant_info_page_text_way_of_authorization',
                        inputType: 'SELECT',
                        comType: 'INPUT',
                        xs: 12,
                        md: 6
                    },
                    {
                        key: 'discount_info',
                        label: 'restaurant_info_page_text_discount_information_discount_module',
                        comType: 'INPUT',
                        contentType: 'number',
                        InputProps: {
                            endAdornment: <InputAdornment position='end'>%</InputAdornment>
                        },
                        xs: 12,
                        md: 6
                    },
                    {
                        key: 'discount_annual',
                        label: 'restaurant_info_page_text_discount_information_discount_annual',
                        comType: 'INPUT',
                        contentType: 'number',
                        InputProps: {
                            endAdornment: <InputAdornment position='end'>%</InputAdornment>
                        },
                        xs: 12,
                        md: 6
                    },
                    {
                        key: 'customer_mark',
                        label: 'restaurant_info_page_text_customer_marks',
                        inputType: 'INPUT',
                        comType: 'INPUT',
                        multiline: true,
                        multiRowsNumber: 3,
                        xs: 12
                    }
                ]
            },]
    },
    // 地址信息数据
    {
        key: 'address',
        title: 'restaurant_info_page_text_address',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'local',
                label: 'address_component_text_address',
                inputType: 'GOOGLE_PLACE',
                comType: 'INPUT',
                xs: 12,
                md: 12,
            },
            {
                key: 'home_umber',
                label: 'restaurant_info_page_text_home_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4
            },
            {
                key: 'postcode',
                label: 'restaurant_info_page_text_postcode',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4
            },
            {
                key: 'city',
                label: 'restaurant_info_page_text_city',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4
            },
            {
                key: 'state',
                label: 'restaurant_info_page_text_state',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6
            },
            {
                key: 'country',
                label: 'restaurant_info_page_text_country',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6
            },
        ]
    },
    // 会计师信息
    {
        key: 'accountant',
        title: 'restaurant_info_page_text_accountant_information',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [{
            key: 'accountant_name',
            label: 'restaurant_info_page_text_contact_person',
            inputType: 'INPUT',
            comType: 'INPUT',
            xs: 12,
            md: 12
        },
        {
            key: 'accountant_phone_prefix',
            label: 'general_text_country_code',
            inputType: 'COUNTRY_SELECT',
            comType: 'INPUT',
            xs: 2,
            md: 2
        },
        {
            key: 'accountant_phone',
            label: 'restaurant_info_page_text_phone',
            inputType: 'INPUT',
            comType: 'INPUT',
            regularType: 'phone',
            xs: 10,
            md: 10
        }
        ]
    },
    // 员工信息
    {
        key: 'staff_info',
        title: 'restaurant_info_page_text_owner_information',
        md: 12,
        xs: 12,
        hidden: true,
        children: [
            {
                key: 'staff_info_list',
                comType: 'TABLE',
                xs: 12,
            },
        ]
    },
    // 餐厅税务信息
    {
        key: 'tax',
        title: 'restaurant_info_page_text_restaurant_tax_information',
        rowSpacing: 6,
        children: [
            {
                key: 'reg_name',
                label: 'restaurant_info_page_text_company',
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'regName',
                xs: 12
            },
            {
                key: 'reg_fiscal_code',
                label: 'restaurant_info_page_text_fiscal_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'fiscalCode',
                xs: 12
            },
            {
                key: 'reg_vat_number',
                label: 'restaurant_info_page_text_vat_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'vatNumber',
                xs: 12
            },
            {
                key: 'reg_pec',
                label: 'restaurant_info_page_text_PEC',
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'email',
                xs: 12,
                md: 0
            },
            {
                key: 'reg_des_code',
                label: 'restaurant_info_page_text_client_recipient_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'recipientCode',
                xs: 12
            },
        ]
    },
    // 餐厅税务地址
    {
        key: 'taxAddress',
        title: 'restaurant_info_page_text_restaurant_tax_address',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'reg_local',
                label: 'address_component_text_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12
            },
            {
                key: 'reg_additional_address',
                label: 'restaurant_info_page_text_additional_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12
            },
            {
                key: 'reg_postcode',
                label: 'restaurant_info_page_text_postcode',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_city',
                label: 'restaurant_info_page_text_city',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6
            },
            {
                key: 'reg_state',
                label: 'restaurant_info_page_text_state',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regName',
                xs: 6,
                md: 6
            },
            {
                key: 'reg_country',
                label: 'restaurant_info_page_text_country',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regName',
                xs: 6,
                md: 6
            },
            //市区
            {
                key: 'reg_municipality',
                label: 'restaurant_info_page_text_district',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regNameSpain120',
                md: 6,
                xs: 12,
                inputProps: {
                    minLength: 1,
                    maxLength: 120
                }
            },
            // 门牌号
            {
                key: 'reg_street_number',
                label: 'restaurant_info_page_text_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regNameSpain20',
                md: 6,
                xs: 12,
                inputProps: {
                    minLength: 1,
                    maxLength: 20
                }
            },
            // 区域
            {
                key: 'reg_territory',
                label: 'restaurant_info_page_text_region',
                inputType: 'SELECT',
                comType: 'INPUT',
                md: 6,
                xs: 12,
                items: SPAIN_CITY_AREA
            },
        ]
    },
    // 餐厅法人信息
    {
        key: 'legal_person',
        title: 'warrant_page_text_legal_entity_info',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'corp_name',
                label: 'warrant_page_text_legal_entity_name',
                inputType: 'INPUT',
                comType: 'INPUT',
                md: 6,
                xs: 12,
            },
            {
                key: 'corp_vat_number',
                label: 'restaurant_info_page_text_vat_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                md: 6,
                xs: 12,
            },
            {
                key: 'corp_local',
                label: 'address_component_text_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12
            },
            {
                key: 'corp_additional_address',
                label: 'restaurant_info_page_text_additional_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12
            },
            {
                key: 'corp_postcode',
                label: 'restaurant_info_page_text_postcode',
                inputType: 'INPUT',
                comType: 'INPUT',
                md: 6,
                xs: 12,
            },
            {
                key: 'corp_city',
                label: 'restaurant_info_page_text_city',
                inputType: 'INPUT',
                comType: 'INPUT',
                md: 6,
                xs: 12,
            },
            {
                key: 'corp_state',
                label: 'restaurant_info_page_text_state',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regName',
                md: 6,
                xs: 12,
            },
            {
                key: 'corp_country',
                label: 'restaurant_info_page_text_country',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regName',
                md: 6,
                xs: 12,
            },
            //市区
            {
                key: 'corp_municipality',
                label: 'restaurant_info_page_text_district',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regNameSpain120',
                md: 6,
                xs: 12,
                inputProps: {
                    minLength: 1,
                    maxLength: 120
                }
            },
            // 门牌号
            {
                key: 'corp_street_number',
                label: 'restaurant_info_page_text_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'regNameSpain20',
                md: 6,
                xs: 12,
                inputProps: {
                    minLength: 1,
                    maxLength: 20
                }
            },
        ]
    },
    // 餐厅扩展功能信息
    {
        key: 'extensions',
        title: 'restaurant_extensions_page_text_restaurant_extension_function_information',
        md: 12,
        xs: 12,
        hidden: true,
        children: [
            {
                key: 'extensions_list',
                comType: 'TABLE',
                xs: 12,
            },
        ]
    },

    // GYB管理信息
    {
        key: 'gyb_info',
        title: 'gyb_page_text_GYB_management_information',
        md: 12,
        xs: 12,
        hidden: true,
        children: [
            {
                key: 'gyb_info_list',
                comType: 'TABLE',
                xs: 12,
            },
        ]
    },
    // Aruba认证信息
    {
        key: 'aruba',
        title: 'gyb_page_text_aruba_authentication_information',
        md: 6,
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        hidden: true,
        children: [
            {
                key: 'Aruba_username',
                label: 'restaurant_page_input_text_aruba_account',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 6
            },
            {
                key: 'Aruba_password',
                label: 'restaurant_page_input_text_aruba_password',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 6
            },
            {
                key: 'activation_time',
                label: 'restaurant_page_input_text_active_date',
                inputType: 'DATE',
                comType: 'INPUT',
                xs: 12,
                md: 6,
            },
        ]
    },
    // Plateform Web API（第三方预订，紧挨 Aruba 认证信息下方、上下布局）
    {
        key: 'plateform_api',
        title: 'restaurant_page_title_plateform_web_api',
        md: 6,
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'plateform_api_user',
                label: 'restaurant_page_input_text_plateform_api_user',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12
            },
            {
                key: 'plateform_api_password',
                label: 'restaurant_page_input_text_plateform_api_password',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12
            },
        ]
    },
    // 通道
    {
        key: 'tunnel',
        title: 'restaurant_page_input_text_restaurant_tunnel_info_configuration',
        md: 6,
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'database_host',
                label: 'restaurant_page_input_text_restaurant_host',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'description',
                xs: 12,
                md: 6
            },
            {
                key: 'database_port',
                label: 'restaurant_page_input_text_restaurant_port',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'maxNumberSix',
                xs: 12,
                md: 6
            },
            {
                key: 'database_port_array',
                comType: 'CUSTOMCHILDREN',
                xs: 12,
                md: 12
            },
            {
                key: 'head',
                label: 'restaurant_info_page_text_qop_WAN_port_address',
                inputType: 'SELECT',
                comType: 'INPUT',
                xs: 12,
                md: 3
            },
            {
                key: 'url',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 9,
                label: 'ECCO'
            },

            {
                key: 'port',
                label: 'restaurant_info_page_text_local_port',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'maxNumberSix',
                xs: 12,
                md: 3
            },
            {
                key: 'qop_efr_url_display',
                comType: 'CUSTOMCHILDREN',
                xs: 12,
                md: 9
            },
        ]
    },
    // core file相关  餐厅版本信息2.5
    {
        key: 'core_file',
        title: 'core_file_component_core_file_related',
        md: 12,
        xs: 12,
        hidden: true,
        children: [
            {
                key: 'core_file_list',
                comType: 'TABLE',
                xs: 12,
            },
        ]
    },
    // Fiskaly 设置
    {
        key: 'fiskaly_settings',
        title: 'Fiskaly',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        md: 12,
        xs: 12,
        children: [
            {
                key: 'fiskaly_manage_organization_key',
                label: 'Fiskaly API KEY',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                disabledInput: true
            },
            {
                key: 'fiskaly_manage_organization_secret',
                label: 'Fiskaly API SECRET',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                disabledInput: true
            },
            {
                key: 'fiskaly_manage_organization_user_id',
                comType: 'CUSTOMCHILDREN',
                xs: 12,
            },
            {
                key: 'fiskaly_sign_info',
                comType: 'TABLE',
                xs: 12,
            },
            {
                key: 'fiskaly_client_info',
                comType: 'TABLE',
                xs: 12,
            },
        ]
    }
]

export default observer(function RestaurantInfo(props: {
    restaurantInfoState: RestaurantInfoState,
    RestaurantInfoCardConfig: CardFormConfig[],
}) {
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
    useTranslation();
    // const useData = MobxObjectsManager.get(RestaurantInfoState);
    // useManualRemove(RestaurantInfoState);
    const useData = props.restaurantInfoState;

    // 骨架屏
    const [skeleton, enableSkeleton] = React.useState<boolean>(true);

    React.useEffect(() => {
        initDialog();
        return () => {
            // 卸载清空表单数据
            useData.clearFormInfo();
        }
    }, []);

    const initDialog = async () => {
        enableSkeleton(true);
        await useData.init();
        enableSkeleton(false);
    }

    // 员工绑定
    const staffInfoListRenderFeatures = (row: Staff): React.ReactNode => {
        return (
            <TableRowFeatures
                buttons={[
                    {
                        variant: 'contained',
                        color: 'secondary',
                        titleText: i18n.t('general_text_delete'),
                        children: (<CloseSharp />),
                        handleClick: () => {
                            return useData.updateConfirmDialog({
                                visible: true,
                                title: '',
                                content: '',
                                handleClick: () => { return row._id && useData.unbind(row); }
                            })
                        }
                    }
                ]} />
        )
    }

    // 密钥
    const extensionsRenderFeatures = (row: SecretKey): React.ReactNode => {
        return (
            <TableRowFeatures
                buttons={[
                    {
                        color: 'secondary',
                        action: 'DELETE',
                        handleClick: () => {
                            return useData.updateConfirmDialog({
                                visible: true,
                                title: '',
                                content: '',
                                handleClick: () => { return row._id && useData.deleteSecretKey(row._id); }
                            })
                        }
                    }, {
                        action: 'REFRESH',
                        handleClick: () => {
                            return useData.updateConfirmDialog({
                                visible: true,
                                title: '',
                                content: i18n.t('restaurant_extensions_page_text_do_you_need_refresh_key'),
                                handleClick: () => { return row._id && useData.refreshSecretKey(row._id); }
                            })
                        }
                    }, {
                        action: 'VIEW',
                        handleClick: () => {
                            return useData.updateExtensionsDialog({
                                open: true, secretKey: row, dialogType: 'EDIT',
                                onSave: async (params) => { await useData.editExtensions(params); }
                            })
                        }
                    }, {
                        handleClick: () => {
                            useData.downloadKeyFile(row);
                        },
                        titleText: i18n.t('general_text_download'),
                        children: <GetApp />
                    }
                ]} />
        )
    }

    // Fiskaly Client Info
    const fiskalyClientInfoRenderFeatures = (row: FiskalyClientInfo): React.ReactNode => {
        return (
            <TableRowFeatures
                buttons={[
                    {
                        color: 'secondary',
                        action: 'DELETE',
                        handleClick: () => {
                            return useData.updateConfirmDialog({
                                visible: true,
                                title: '',
                                content: '',
                                handleClick: async () => await useData.unbindDisableFiskalyClientInfo(row, 'REMOVED')
                            })
                        }
                    }
                ]} />
        )
    }
    // GYB
    const gybInfoRenderFeatures = (row: GybDevice): React.ReactNode => {

        return (
            <TableRowFeatures
                buttons={[
                    {
                        color: 'secondary',
                        titleText: i18n.t('general_text_delete'),
                        children: (<CloseSharp />),
                        handleClick: () => {
                            useData.updateConfirmDialog({
                                visible: true,
                                title: '',
                                content: '',
                                handleClick: () => { return useData.GYBhandleDelete(row); }
                            })
                        }
                    }, {
                        titleText: i18n.t('gyb_page_text_set_default_device'),
                        children: (<Settings />),
                        handleClick: () => {
                            useData.updateConfirmDialog({
                                visible: true,
                                title: '',
                                content: i18n.t('gyb_page_text_set_default_device'),
                                handleClick: () => { return useData.handleDefaultSetting(row); }
                            })
                        }
                    }, {
                        titleText: i18n.t('general_text_details'),
                        children: (<RateReview />),
                        handleClick: () => {
                            useData.updateGYBDialog({
                                open: true,
                                dialogType: 'PREVIEW',
                                onSaveCallback: useData.onSaveGYB,
                                GYBDeviceInfo: row
                            });
                        }
                    }, {
                        titleText: i18n.t('operation_record_refresh_function_key'),
                        children: (<Refresh />),
                        handleClick: () => {
                            useData.handleUpdate(row);
                        }
                    }
                ]} />
        )
    }

    const coreFileLogRenderFeatures = (row: CoreFileLog): React.ReactNode => {
        return (
            <TableRowFeatures
                buttons={[
                    {
                        titleText: i18n.t('general_text_details'),
                        children: (<RateReview />),
                        handleClick: () => {
                            return useData.updateCoreFlieLogDialog({
                                open: true, info: row, dialogType: 'PREVIEW',
                                onSave: (params) => { useData.editExtensions(params); }
                            })
                        }
                    },
                ]} />
        )
    }

    /**
     * 渲染双端口输入区，保持 ECCO/EFR 项目唯一。
     * @returns 双端口表单区域
     */
    const renderMultiDatabasePortInputs = (): React.ReactNode => {
        // 预览态与经销商账号不可编辑双端口配置
        const disabled = useData.componentType === 'PREVIEW' || accountState.accountType === 'RESELLER';
        return (
            <Grid container spacing={2}>
                {useData.multiDatabasePortItems.map((item, index) => (
                    <React.Fragment key={`${item.project}_${index}`}>
                        <Grid item xs={12} md={3}>
                            <CommonInput
                                inputType='SELECT'
                                fullWidth
                                label='Project'
                                size='small'
                                disabled={disabled}
                                items={useData.getDatabaseTunnelProjectOptions()}
                                value={item.project}
                                onChange={(event) => {
                                    useData.updateMultiDatabasePortProject(index, event.target.value as any);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <CommonInput
                                inputType='INPUT'
                                fullWidth
                                label='restaurant_page_input_text_restaurant_port'
                                size='small'
                                disabled={disabled}
                                value={item.port}
                                inputProps={{ maxLength: 6 }}
                                onChange={(event) => {
                                    useData.updateMultiDatabasePortPort(index, event.target.value);
                                }}
                            />
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>
        );
    }

    const cardConfig: CardFormConfig[] = props.RestaurantInfoCardConfig.map((item) => {
        let extraParentConfig = {};
        // 是否是意大利
        const isItaly = useData.editRestaurantData.country_code === '+39';
        // 是否是西班牙
        const isSpain = useData.editRestaurantData.country_code === '+34';
        // 是否有fiskaly信息
        const { fiskaly_signer_id, fiskaly_serial_number, fiskaly_signer_status } =
            useData.restaurantInfo || {};
        // 是否有fiskaly信息
        const hasFiskalyInfo =
            !!(fiskaly_signer_id || fiskaly_serial_number);


        // 隐藏第一步骤，第一步骤一成功执行，有组织id fiskaly_manage_organization_id
        const isHiddenStepOne = useData.restaurantInfo.fiskaly_manage_organization_id;

        // 隐藏第二步骤，第二步骤成功执行，有管理key和secret
        const isHiddenStepTwo = (useData.editRestaurantData.fiskaly_manage_organization_key && useData.editRestaurantData.fiskaly_manage_organization_secret);

        // 隐藏第三步骤，第三步骤已成功执行，taxpayer_status是true
        const isHiddenStepThree = useData.restaurantInfo.taxpayer_status;

        // 隐藏第四步骤，第四步骤已成功执行
        const isVerifactu = isVerifactuArea(useData.editRestaurantData.reg_territory || '')
        const isHiddenStepFour = useData.isDisabledLegalPerson && useData.restaurantInfo.restaurant_unsigned_agreement;

        // 商家声明是否上传
        const isMerchantStatement = useData.restaurantInfo.fiskaly_upload_agreemen === '1' && useData.restaurantInfo.restaurant_agreement;

        // 显示禁用Fiskaly Client Info按钮
        const showDisableFiskalyClientInfoButton = useData.restaurantInfo.fiskaly_manage_organization_id && useData.restaurantInfo.fiskaly_signer_status !== 'DISABLED'

        // 预览协议
        const previewAgreementUrl = useData.isDisabledLegalPerson ? (useData.restaurantInfo.restaurant_agreement || useData.restaurantInfo.restaurant_unsigned_agreement || '') : useData.restaurantInfo.restaurant_unsigned_agreement;

        switch (item.key) {
            case 'aruba':
                extraParentConfig = {
                    hidden: !isItaly || useData.componentType && ['ADD', 'BASE_INFO'].includes(useData.componentType),
                }
                break;
            case 'tunnel':
                extraParentConfig = {
                    actionRender:
                        (<>
                            {
                                accountState.accountType === 'RESELLER' ? null :
                                    <ButtonComponent
                                        variant='outlined'
                                        disabled={useData.componentType === 'PREVIEW'}
                                        handleClick={async () => { await useData.handleGenerateTunnel('single') }}
                                        titleText={i18n.t('restaurant_page_tooltip_generate_single_tunnel')}
                                        iconBtn={false}
                                    >
                                        {i18n.t('restaurant_page_button_generate_single_tunnel')}
                                    </ButtonComponent>
                            }
                            {
                                accountState.accountType === 'RESELLER' ? null :
                                    <ButtonComponent
                                        variant='outlined'
                                        disabled={useData.componentType === 'PREVIEW'}
                                        color='info'
                                        handleClick={async () => { await useData.handleGenerateTunnel('multi') }}
                                        titleText={i18n.t('restaurant_page_tooltip_generate_dual_tunnel')}
                                        iconBtn={false}
                                    >
                                        {i18n.t('restaurant_page_button_generate_dual_tunnel')}
                                    </ButtonComponent>
                            }
                            <ButtonComponent
                                variant='outlined'
                                disabled={useData.componentType === 'ADD'}
                                handleClick={async () => { await useData.downloadFile() }}
                                titleText={i18n.t('general_text_download')}
                            >
                                <GetApp />
                            </ButtonComponent>
                        </>)
                }
                break;
            case 'fiskaly_settings':
                extraParentConfig = {
                    hidden: !['EDIT'].includes(useData.componentType || ''),
                }
                break;
            case 'legal_person':
                extraParentConfig = {
                    hidden: !isVerifactu || !isSpain,
                    actionRender: ['EDIT'].includes(useData.componentType || '') ?
                        <Box display={'flex'} alignItems='center'>
                            {
                                !isHiddenStepFour ?
                                    <ButtonComponent
                                        variant='outlined'
                                        disabled={useData.componentType === 'ADD'}
                                        handleClick={async () => { await useData.getFiskalyCredentialsStepFour('4') }}
                                    >
                                        {`4. ${i18n.t('warrant_page_text_generate_agreement')}`}
                                    </ButtonComponent>
                                    :
                                    <div className="FCC">
                                        <StatusCheckLabel
                                            text={i18n.t('warrant_page_text_generated')}
                                        />
                                        {
                                            useData.isDisabledLegalPerson &&
                                            <ButtonComponent
                                                variant='outlined'
                                                action='VIEW'
                                                handleClick={() => useData.updateConfirmDialogLegalPerson()}
                                                titleText={i18n.t('general_text_edit')}
                                            />
                                        }
                                    </div>

                            }
                            {
                                useData.isDisabledLegalPerson &&
                                <>

                                    {
                                        isMerchantStatement ?
                                            <StatusCheckLabel
                                                text={i18n.t('fiskaly_setting_status_uploaded')}
                                            /> :
                                            <StatusCheckLabel
                                                status='fail'
                                                text={i18n.t('fiskaly_setting_status_not_uploaded')}
                                            />
                                    }
                                </>
                            }

                            <ButtonComponent
                                variant='outlined'
                                action='DETAIL'
                                handleClick={() => {
                                    useData.updatePreviewAgreementDialog({
                                        open: true,
                                        url: previewAgreementUrl || ''
                                    })
                                }}
                                titleText={i18n.t('general_text_preview')}
                            />

                        </Box>
                        :
                        null

                }
                break;
            case 'taxAddress':
                extraParentConfig = {
                    actionRender: (['EDIT'].includes(useData.componentType || '') && isSpain ?
                        <Box display={'flex'} alignItems='center' sx={{ height: '52px' }}>
                            {!isHiddenStepTwo ?
                                <ButtonComponent
                                    variant='outlined'
                                    disabled={useData.componentType === 'ADD'}
                                    handleClick={async () => { await useData.getFiskalyCredentialsStepOneTwoThree('2') }}
                                >
                                    {`2. ${i18n.t('warrant_page_text_generate_voucher')}`}
                                </ButtonComponent>
                                :
                                <StatusCheckLabel
                                    text={i18n.t('fiskaly_page_text_step_two_certificate_generated')}
                                />


                            }
                            {
                                !isHiddenStepThree ?
                                    <ButtonComponent
                                        variant='outlined'
                                        disabled={useData.componentType === 'ADD'}
                                        handleClick={async () => { await useData.getFiskalyCredentialsStepOneTwoThree('3') }}
                                    >
                                        {`3. ${i18n.t('warrant_page_text_register_taxpayer')}`}
                                    </ButtonComponent>
                                    :
                                    <StatusCheckLabel
                                        text={i18n.t('fiskaly_page_text_step_three_taxpayer_registered')}
                                    />
                            }
                        </Box> : null)
                }
                break;
            case 'tax':
                extraParentConfig = {
                    actionRender: (['EDIT'].includes(useData.componentType || '') && isSpain ?
                        <Box display={'flex'} alignItems='center' sx={{ height: '52px' }}>
                            {
                                !isHiddenStepOne ?
                                    <>
                                        <AsyncCheckboxWithLoading
                                            checked={!useData.editRestaurantData.fiskaly_environment}
                                            label={(
                                                <Typography variant='body2'>
                                                    Test
                                                </Typography>
                                            )}
                                            onChange={(val) => useData.updateEditRestaurantData(!val, 'fiskaly_environment')}
                                        />
                                        <ButtonComponent
                                            variant='outlined'
                                            disabled={useData.componentType === 'ADD'}
                                            handleClick={async () => { await useData.getFiskalyCredentialsStepOneTwoThree('1') }}
                                        >
                                            {`1. ${i18n.t('warrant_page_text_register_organization')}`}
                                        </ButtonComponent>
                                    </>
                                    :
                                    <StatusCheckLabel
                                        text={i18n.t('fiskaly_page_text_step_one_organization_registered')}
                                    />

                            }
                            {
                                showDisableFiskalyClientInfoButton &&
                                <ButtonComponent
                                    variant='outlined'
                                    handleClick={() => useData.updateConfirmDialog({
                                        visible: true,
                                        title: '',
                                        content: i18n.t('restaurant_info_page_text_fiskaly_disable_client_and_signer_confirm'),
                                        handleClick: async () => await useData.unbindDisableTax()
                                    })}
                                    titleText={i18n.t('restaurant_info_page_text_fiskaly_disable_client_and_signer_title')}
                                >
                                    <NotInterestedIcon />
                                </ButtonComponent>
                            }
                        </Box> : null)
                }
                break;
            case 'staff_info':
                extraParentConfig = {
                    hidden: useData.componentType && ['ADD', 'BASE_INFO'].includes(useData.componentType),
                    actionRender: (useData.componentType === 'PREVIEW' ? <></> : <ButtonComponent
                        variant='outlined'
                        handleClick={() => {
                            useData.updateResponsabileDialog({ visible: true })
                        }}
                        titleText={i18n.t('bind_account_component_bind_new_account')}
                    >
                        <Add />
                    </ButtonComponent>)
                }
                break;
            case 'extensions':
                extraParentConfig = {
                    hidden: useData.componentType && ['ADD', 'BASE_INFO'].includes(useData.componentType),
                    actionRender: (
                        useData.componentType === 'PREVIEW' ? <></>
                            :
                            <TableRowFeatures
                                buttons={[
                                    {
                                        variant: 'outlined',
                                        titleText: i18n.t('general_text_add'),
                                        children: (<Add />),
                                        handleClick: () => {
                                            if (useData?.restaurantInfo?.secret_key?.length) {
                                                GlobalNotification.info(i18n.t('restaurant_extensions_page_text_only_five_keys_most'))
                                            } else {
                                                useData.updateExtensionsDialog({
                                                    open: true, dialogType: 'ADD',
                                                    onSave: async (params) => { await useData.createSecretKey(params); }
                                                })
                                            }
                                        }
                                    }, {
                                        variant: 'outlined',
                                        titleText: i18n.t('restaurant_info_page_text_private_key_fix_desc'),
                                        children: (<Settings />),
                                        handleClick: () => { useData.handleFixPrivateKey() }
                                    }
                                ]} />
                    )
                }
                break;
            case 'gyb_info':
                extraParentConfig = {
                    // 国家选择非意大利的时候， 电子发票收件人编码不显示； GYB管理信息和Aruba认证信息不显示
                    hidden: !isItaly || useData.componentType && ['ADD', 'BASE_INFO'].includes(useData.componentType),
                    // 经销商不能编辑gyb
                    actionRender: (useData.componentType === 'PREVIEW' || accountState.accountType === 'RESELLER' ? <></> : <ButtonComponent
                        variant='outlined'
                        handleClick={() => { useData.updateGYBDialog({ open: true, dialogType: 'ADD', onSaveCallback: useData.onSaveGYB }) }}
                        titleText={i18n.t('general_text_add')}
                    >
                        <Add />
                    </ButtonComponent>)
                }
                break;
            case 'core_file':
                extraParentConfig = {
                    hidden: (useData.componentType && ['ADD', 'BASE_INFO'].includes(useData.componentType)) || useData.editRestaurantData?.restaurant_version !== '2.5',
                    actionRender: (<ButtonComponent
                        variant='outlined'
                        handleClick={() => { useData.getCoreFileAasKey(); useData.getCoreFileRsaPrivateKey(); }}
                        titleText={i18n.t('general_text_download')}
                    >
                        <GetApp />
                    </ButtonComponent>)
                }
                break;
            default:
                break;
        }

        // 是否禁用输入框  reg_name、reg_territory、reg_fiscal_code、reg_vat_number，如果注册了Fiskaly就不能修改了
        const disabledTaxInput = useData.componentType === 'PREVIEW' || useData.restaurantInfo.fiskaly_manage_organization_id && useData.restaurantInfo.fiskaly_signer_status !== 'DISABLED';
        return {
            ...item,
            ...extraParentConfig,
            children: item?.children?.map((childrenItem) => {
                let extraConfig = {};
                switch (childrenItem.key) {
                    case 'avatar':
                        extraConfig = {
                            isDisabledUpload: useData.componentType === 'PREVIEW',
                            handleChangeAvatar: ((_avatarUrl: string, file: File) => {
                                return useData.onChangeAvatar(file);
                            })
                        }
                        break;
                    case 'city':
                        extraConfig = {
                            // 校验城市必填  用于餐厅隧道下载时的校验
                            required: useData.validateCityRequired ?? undefined,
                            regularType: useData.validateCityRequired ? 'required' : undefined,
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'setting_restaurant_operating_status':
                    case 'ex_string_id':
                        extraConfig = {
                            // 新增模式下隐藏
                            hidden: useData.componentType === 'ADD',
                            // 预览模式下禁用
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    // 以下同为输入框  所以根据是否为预览模式加以禁用
                    case 'nickname':
                    case 'description':
                    case 'home_umber':
                    case 'postcode':
                    case 'state':
                    case 'country':
                    case 'reg_state':
                    case 'reg_country':
                    case 'Aruba_username':
                    case 'Aruba_password':
                    case 'activation_time':
                    case 'plateform_api_user':
                    case 'plateform_api_password':
                    case 'accountant_name':
                    case 'accountant_phone':
                    case 'accountant_phone_prefix':
                    case 'reg_additional_address':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'local':
                        extraConfig = {
                            // 根据当前选择的国家
                            language: useData.getLanguage(),
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'reg_des_code':
                        extraConfig = {
                            // 国家选择非意大利的时候， 电子发票收件人编码不显示
                            hidden: !isItaly,
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'reg_city':
                    case 'reg_local':
                        extraConfig = {
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_CITY_REGULAR[useData.editRestaurantData.country_code || ''],
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 西班牙城市长度限制
                            inputProps: isSpain ? {
                                minLength: 1,
                                maxLength: 120
                            } : undefined
                        }
                        break;
                    case 'reg_postcode':
                        extraConfig = {
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_POSTCODE_REGULAR[useData.editRestaurantData.country_code || ''],
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 西班牙邮编长度限制
                            inputProps: isSpain ? {
                                minLength: 1,
                                maxLength: 20
                            } : undefined,
                        }
                        break;
                    case 'reg_municipality':
                        extraConfig = {
                            InputProps: {
                                endAdornment: <InputAdornment position="start">
                                    <ButtonComponent
                                        variant='text'
                                        handleClick={() => useData.searchMunicipalityByPostcode('reg_postcode', 'reg_municipality')}
                                        titleText={i18n.t('restaurant_info_page_text_search_municipality_by_postcode')}
                                        sx={{ marginRight: -6 }}
                                    >
                                        <SearchIcon />
                                    </ButtonComponent>
                                </InputAdornment>,
                            },
                            hidden: !isSpain,
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'corp_municipality':
                        extraConfig = {
                            InputProps: {
                                endAdornment: <InputAdornment position="start">
                                    <ButtonComponent
                                        variant='text'
                                        handleClick={() => useData.searchMunicipalityByPostcode('corp_postcode', 'corp_municipality')}
                                        titleText={i18n.t('restaurant_info_page_text_search_municipality_by_postcode')}
                                        sx={{ marginRight: -6 }}
                                    >
                                        <SearchIcon />
                                    </ButtonComponent>
                                </InputAdornment>,
                            },
                            hidden: !isSpain,
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'reg_street_number':
                        extraConfig = {
                            hidden: !isSpain,
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'corp_street_number':
                        extraConfig = {
                            hidden: !isSpain,
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'reg_name':
                        extraConfig = {
                            disabledInput: disabledTaxInput,
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_NAME_REGULAR[useData.editRestaurantData.country_code || ''],
                            // 西班牙长度限制
                            inputProps: isSpain ? {
                                minLength: 3,
                                maxLength: 120
                            } : undefined,
                        }
                        break;
                    case 'reg_territory':
                        // 公司名称、区域，如果注册了Fiskaly就不能修改了
                        extraConfig = {
                            hidden: !isSpain,
                            disabledInput: disabledTaxInput,
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'database_host':
                    case 'database_port':
                        extraConfig = {
                            // 经销商端不能编辑餐厅隧道信息配置
                            disabledInput: useData.componentType === 'PREVIEW' || accountState.accountType === 'RESELLER',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            hidden: childrenItem.key === 'database_port' ? useData.isMultiDatabasePortMode : false,
                        }
                        break;
                    case 'database_port_array':
                        extraConfig = {
                            hidden: !useData.isMultiDatabasePortMode,
                            customSubChildren: renderMultiDatabasePortInputs()
                        }
                        break;
                    case 'qop_efr_url_display':
                        extraConfig = {
                            hidden: !useData.QOP_WAN_WARRANT || !useData.editRestaurantData.string_id,
                            customSubChildren: (
                                <Box sx={{ width: '100%' }}>
                                    <CommonInput
                                        inputType="INPUT"
                                        fullWidth
                                        label='EFR'
                                        size="small"
                                        disabled
                                        value={getQopEfrTunnelHost(useData.editRestaurantData.string_id || '')}
                                        onChange={() => undefined}
                                    />
                                </Box>
                            )
                        };
                        break;
                    case 'belonged_group':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(`belonged_group`) !== undefined ? true : false,
                            items: useData.groupAllData?.map(n => ({ value: n.string_id as string, label: n.nickname as string })),
                        }
                        break;
                    case 'time_zone':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(`time_zone`) !== undefined ? true : false,
                            items: useData.countryTimeZone,
                        }
                        break;
                    case 'country_code':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(`country_code`) !== undefined ? true : false,
                            items: useData.countryCodeList || [],
                        }
                        break;
                    case 'restaurant_version':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(`restaurant_version`) !== undefined ? true : false,
                            items: useData.restaurantVersions,
                        }
                        break;
                    case 'head':
                        extraConfig = {
                            // 经销商不能编辑餐厅隧道信息配置
                            disabledInput: useData.componentType === 'PREVIEW' || accountState.accountType === 'RESELLER',
                            inputIsEdited: useData.operateMap.get(`head`) !== undefined ? true : false,
                            items: [
                                { value: 'http', label: 'http' },
                                { value: 'https', label: 'https' }
                            ],
                            hidden: !useData.QOP_WAN_WARRANT
                        }
                        break;
                    case 'url':
                    case 'port':
                        extraConfig = {
                            // 经销商不能编辑餐厅隧道信息配置
                            disabledInput: useData.componentType === 'PREVIEW' || accountState.accountType === 'RESELLER',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            hidden: !useData.QOP_WAN_WARRANT
                        };
                        break;
                    case 'staff_info_list':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                headCellList: [
                                    { id: 'nickname', label: i18n.t('general_table_text_staff_name'), sortStatus: -1 },
                                    { id: 'email', label: i18n.t('general_text_email'), sortStatus: -1 },
                                    {
                                        id: 'phone', label: i18n.t('restaurant_info_page_table_text_staff_phone'), sortStatus: -1,
                                        renderFunction: (row: any) => {
                                            return `${row.phone_prefix || ''} ${row.phone || ''}`
                                        }
                                    },
                                    {
                                        id: 'staff_belonged_group.nickname', label: i18n.t('general_text_belonged_group'), sortStatus: -1,
                                        renderFunction: (row: Staff) => {
                                            return `${row?.staff_belonged_group?.nickname || ''}`
                                        }
                                    },
                                    {
                                        id: 'staff_belonged_group.string_id', label: i18n.t('group_management_page_text_group_identification_code'),
                                        renderFunction: (row: Staff) => {
                                            return <>{row?.staff_belonged_group?.string_id || ''}</>
                                        }
                                    },
                                    {
                                        id: '-1', label: '', sortStatus: -1,
                                        renderFunction: (row: Staff) => {
                                            return useData.componentType !== 'PREVIEW' ? staffInfoListRenderFeatures(row) : <></>
                                        }
                                    }
                                ],
                                list: JSON.stringify(useData.restaurantInfo?.owned_staff?.[0]) !== '{}' ? useData?.restaurantInfo?.owned_staff || [] : [],
                            }
                        }
                        break;
                    case 'extensions_list':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                headCellList: [
                                    { id: 'name', label: i18n.t('responsible_person_info_component_text_name'), sortStatus: -1 },
                                    {
                                        id: 'value', label: i18n.t('restaurant_extensions_page_text_key'), sortStatus: -1,
                                        renderFunction: (row: any) => {
                                            return (<Box className='FC' style={{ wordBreak: 'break-all', minWidth: '200px' }} >
                                                <ButtonComponent
                                                    variant='text'
                                                    handleClick={() => {
                                                        const res = copy(row?.value);
                                                        if (res) GlobalNotification.success(i18n.t('restaurant_page_input_tip_message_copy_successfully'))
                                                    }}>
                                                    <ContentCopy />
                                                </ButtonComponent>
                                                {row?.value}
                                            </Box>)
                                        }
                                    },
                                    {
                                        id: 'creation_time', label: i18n.t('restaurant_extensions_page_text_create_time'), sortStatus: -1,
                                        renderFunction: (row: any) => {
                                            return row?.creation_time ? moment(row.creation_time, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('HH:mm:ss DD/MM/YYYY') : '';
                                        }
                                    },
                                    {
                                        id: '-1', label: '', sortStatus: -1,
                                        renderFunction: (row: SecretKey) => {
                                            return useData.componentType !== 'PREVIEW' ? extensionsRenderFeatures(row) : <></>
                                        }
                                    }
                                ],
                                list: useData?.restaurantInfo?.secret_key || [],
                            }
                        }
                        break;
                    case 'gyb_info_list':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                headCellList:
                                    // 经销商无法操作gyb
                                    useData.componentType === 'PREVIEW' || accountState.accountType === 'RESELLER' ?
                                        [
                                            { id: 'location_id', label: i18n.t('gyb_page_text_registered_id'), sortStatus: -1 },
                                            { id: 'operator', label: i18n.t('gyb_page_text_operator'), sortStatus: -1 },
                                            { id: 'license_code', label: i18n.t('gyb_page_text_GYB_key'), sortStatus: -1 },
                                            { id: 'device_code', label: i18n.t('gyb_page_text_the_device_number'), sortStatus: -1 },

                                        ]
                                        :
                                        [
                                            { id: 'location_id', label: i18n.t('gyb_page_text_registered_id'), sortStatus: -1 },
                                            { id: 'operator', label: i18n.t('gyb_page_text_operator'), sortStatus: -1 },
                                            { id: 'license_code', label: i18n.t('gyb_page_text_GYB_key'), sortStatus: -1 },
                                            { id: 'device_code', label: i18n.t('gyb_page_text_the_device_number'), sortStatus: -1 },
                                            {
                                                id: 'is_default', label: i18n.t('gyb_page_text_default_device'), sortStatus: -1,
                                                renderFunction: (row: any,) => {
                                                    return row.is_default === 1 ? i18n.t('general_text_yes') : i18n.t('general_text_no')
                                                }
                                            },
                                            {
                                                id: '-1', label: '', sortStatus: -1,
                                                renderFunction: (row: any) => {
                                                    return gybInfoRenderFeatures(row)
                                                }
                                            }

                                        ],
                                list: useData?.GYBList || [],
                            }
                        }
                        break;
                    case 'core_file_list':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                headCellList: [
                                    {
                                        id: 'date', label: i18n.t('core_file_component_date'), sortStatus: -1,
                                        renderFunction: (row: any) => {
                                            return `${moment(row.date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD HH:mm:ss')}`
                                        }
                                    },
                                    {
                                        id: 'operatorFirstName', label: i18n.t('core_file_component_operator_name'), sortStatus: -1,
                                        renderFunction: (row: any) => {
                                            return `${row.operatorFirstName || ''} ${row.operatorLastName || ''}`
                                        }
                                    },
                                    { id: 'operatorType', label: i18n.t('core_file_component_operator_type'), sortStatus: -1 },
                                    {
                                        id: '-1', label: '', sortStatus: -1,
                                        renderFunction: (row: any) => {
                                            return coreFileLogRenderFeatures(row)
                                        }
                                    }
                                ],
                                list: useData?.coreFileLog || [],
                                isPagination: true,
                                allCount: useData?.coreFileLog?.length || 0,
                                isUseCustomPagination: true,
                            }
                        }
                        break;
                    case 'reg_fiscal_code':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 非意大利国家忽略必填校验
                            required: isItaly ? childrenItem.required : false,
                            // 意大利国家才校验
                            regularType: isItaly ? 'vatNumber' : undefined,
                        }
                        break;
                    case 'reg_vat_number':
                        extraConfig = {
                            disabledInput: disabledTaxInput,
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 非意大利国家忽略必填校验
                            required: (isItaly || isSpain) ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_VAT_REGULAR[useData.editRestaurantData.country_code || ''],
                        }
                        break;
                    case 'corp_name':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_NAME_REGULAR[useData.editRestaurantData.country_code || ''],
                            // 西班牙长度限制
                            inputProps: isSpain ? {
                                minLength: 3,
                                maxLength: 120
                            } : undefined,
                        }
                        break;
                    case 'corp_vat_number':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_VAT_REGULAR[useData.editRestaurantData.country_code || ''],
                        }
                        break;
                    case 'corp_local':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_CITY_REGULAR[useData.editRestaurantData.country_code || ''],
                        }
                        break;
                    case 'corp_additional_address':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'corp_postcode':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_POSTCODE_REGULAR[useData.editRestaurantData.country_code || ''],
                        }
                        break;
                    case 'corp_city':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 不同的国家使用不同的正则
                            regularType: COUNTRY_REG_CITY_REGULAR[useData.editRestaurantData.country_code || ''],
                        }
                        break;
                    case 'corp_state':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'corp_country':
                        extraConfig = {
                            disabledInput: useData.isDisabledLegalPerson || useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                        }
                        break;
                    case 'reg_pec':
                        extraConfig = {
                            disabledInput: useData.componentType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            // 非意大利国家忽略必填校验
                            required: isItaly ? childrenItem.required : false,
                        }
                        break;
                    case 'fiskaly_manage_organization_user_id':
                        extraConfig = {
                            customSubChildren: (
                                <Box sx={{ mt: -2 }}>
                                    <AsyncCheckboxWithLoading
                                        disabled={useData.componentType === 'PREVIEW'}
                                        checked={!!useData.restaurantInfo.fiskaly_manage_organization_user_id}
                                        label={(
                                            <Typography variant='body2'>
                                                {i18n.t('restaurant_info_page_text_fiskaly_manage_organization_user_id')}
                                            </Typography>
                                        )}
                                        onChange={async (val) => {
                                            await useData.inviteFiskalyChange(val);
                                        }}
                                    />
                                </Box>
                            )
                        }
                        break;
                    case 'fiskaly_client_info':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                headCellList: [
                                    { id: 'fiskaly_client_id', label: i18n.t('restaurant_info_page_table_text_fiskaly_client_id') },
                                    { id: 'fiskaly_invoice_series', label: i18n.t('restaurant_info_page_table_text_invoice_series') },
                                    { id: 'pos_name', label: i18n.t('restaurant_info_page_table_text_pos_name') },
                                    {
                                        id: 'status', label: i18n.t('restaurant_info_page_table_text_fiskaly_client_status'),
                                        renderFunction: (row) => {
                                            return row?.status === 'ENABLED' ?
                                                <Button
                                                    color='success'
                                                    variant='contained'
                                                    onClick={() => useData.updateConfirmDialog({
                                                        visible: true,
                                                        title: '',
                                                        content: i18n.t('restaurant_info_page_button_unbind_fiskaly_client'),
                                                        handleClick: async () => await useData.unbindDisableFiskalyClientInfo(row, 'DISABLED')
                                                    })}
                                                    sx={{ color: '#fff' }}
                                                >
                                                    {i18n.t('restaurant_info_page_text_status_enabled')}
                                                </Button>
                                                :
                                                <Button
                                                    disabled
                                                    color='error'
                                                    variant='contained'
                                                >
                                                    {i18n.t('restaurant_info_page_text_status_disabled')}
                                                </Button>
                                        }
                                    },
                                    { id: 'workstations_id', label: i18n.t('restaurant_info_page_table_text_workstation_id') },
                                    {
                                        id: '-1', label: '', sortStatus: -1,
                                        renderFunction: (row: FiskalyClientInfo) => row.status === 'DISABLED' ? fiskalyClientInfoRenderFeatures(row) : null
                                    }
                                ],
                                list: JSON.stringify(useData.restaurantInfo?.fiskaly_client_info?.[0]) !== '{}' ? useData?.restaurantInfo?.fiskaly_client_info || [] : [],
                            }
                        }
                        break;
                    case 'fiskaly_sign_info': {
                        // 个人税号时展示可编辑 activity_code 列（非必填，label 不走 i18n）
                        const showActivityCode = shouldShowFiskalyActivityCodeColumn(
                            useData.restaurantInfo?.vat_number_is_personal,
                        );
                        // 表头列：签名信息 + 条件列 activity_code
                        const fiskalySignHeadCells = [
                            {
                                id: 'fiskaly_signer_id', label: 'Signer ID', renderFunction: (row: {
                                    fiskaly_signer_id?: string;
                                }) => {
                                    return row?.fiskaly_signer_id ? <Box className='FC' style={{ wordBreak: 'break-all' }} >
                                        <ButtonComponent
                                            variant='text'
                                            handleClick={() => {
                                                const res = copy(row.fiskaly_signer_id || '');
                                                if (res) GlobalNotification.success(i18n.t('restaurant_page_input_tip_message_copy_successfully'))
                                            }}>
                                            <ContentCopy />
                                        </ButtonComponent>
                                        {row?.fiskaly_signer_id}
                                    </Box> : null
                                }
                            },
                            {
                                id: 'fiskaly_serial_number', label: 'Serial No.', renderFunction: (row: {
                                    fiskaly_serial_number?: string;
                                }) => {
                                    return row?.fiskaly_serial_number ? <Box className='FC' style={{ wordBreak: 'break-all' }} >
                                        <ButtonComponent
                                            variant='text'
                                            handleClick={() => {
                                                const res = copy(row.fiskaly_serial_number || '');
                                                if (res) GlobalNotification.success(i18n.t('restaurant_page_input_tip_message_copy_successfully'))
                                            }}>
                                            <ContentCopy />
                                        </ButtonComponent>
                                        {row?.fiskaly_serial_number}
                                    </Box> : null
                                }
                            },
                            ...(showActivityCode
                                ? [{
                                    id: 'fiskaly_activity_code',
                                    label: 'activity_code',
                                    // 单元格内可编辑，绑定餐厅表单 fiskaly_activity_code
                                    renderFunction: () => (
                                        <CommonInput
                                            inputType="INPUT"
                                            fullWidth
                                            size="small"
                                            disabled={useData.componentType === 'PREVIEW'}
                                            value={useData.editRestaurantData?.fiskaly_activity_code || ''}
                                            onChange={(e) => {
                                                useData.updateEditRestaurantData(
                                                    e.target.value,
                                                    'fiskaly_activity_code',
                                                );
                                            }}
                                        />
                                    ),
                                }]
                                : []),
                            {
                                id: 'fiskaly_signer_status', label: i18n.t('restaurant_info_page_status'), renderFunction: (row: {
                                    fiskaly_signer_status?: string;
                                }) => {
                                    return <>
                                        {row?.fiskaly_signer_status === 'ENABLED' ?
                                            <Button
                                                color='success'
                                                variant='contained'
                                                sx={{ color: '#fff' }}
                                            >
                                                {i18n.t('restaurant_info_page_text_status_enabled')}
                                            </Button>
                                            :
                                            null

                                        }
                                        {
                                            row?.fiskaly_signer_status === 'DISABLED' ?
                                                <Button
                                                    disabled
                                                    color='error'
                                                    variant='contained'
                                                >
                                                    {i18n.t('restaurant_info_page_text_status_disabled')}
                                                </Button>
                                                :
                                                null
                                        }
                                    </>
                                }
                            }
                        ];
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                headCellList: fiskalySignHeadCells,
                                // 有签名信息，或个人税号需编辑 activity_code 时至少展示一行
                                list: shouldShowFiskalySignInfoList(
                                    hasFiskalyInfo,
                                    useData.restaurantInfo?.vat_number_is_personal,
                                )
                                    ? [
                                        {
                                            fiskaly_signer_id,
                                            fiskaly_serial_number,
                                            fiskaly_signer_status,
                                            fiskaly_activity_code:
                                                useData.editRestaurantData?.fiskaly_activity_code || '',
                                        },
                                    ]
                                    : []
                            }
                        }
                        break;
                    }

                    default:
                        break;
                }
                // 允许空校验
                const allowNullVerification = useData.allowNullVerification
                return {
                    ...childrenItem,
                    ...extraConfig,
                    isEmpty: allowNullVerification,
                    onChange: async (e) => {
                        useData.updateEditRestaurantData(e.target.value, childrenItem.key);
                        // 核心文件日志 2.5餐厅
                        if (useData.componentType !== 'ADD' && 'restaurant_version' && e.target.value === '2.5') {
                            await useData.getCoreFileLog();
                        }
                    },
                    handleMultipleChange: (value) => {
                        return useData.updateEditRestaurantData(value, childrenItem.key);
                    },
                    handleChangeCountry: (value) => {
                        return useData.updateEditRestaurantData(value, childrenItem.key);
                    },
                    handleChangePicker: (value) => {
                        const pickerValue = value ? moment(value).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : null;
                        useData.updateEditRestaurantData(pickerValue || '', childrenItem.key);
                    },
                    handleChangeGooglePlace: (val) => {
                        // 更新地址、邮编、国家、城市、省份
                        useData.updateEditRestaurantData(val.value || '', childrenItem.key);
                        useData.updateEditRestaurantData(val.postalCode || '', 'postcode');
                        useData.updateEditRestaurantData(val.country || '', 'country');
                        useData.updateEditRestaurantData(val.city || '', 'city');
                        useData.updateEditRestaurantData(val.state || '', 'state');
                    },
                }

            }),
            subCardConfig: item?.subCardConfig?.map((subCardItm) => {
                subCardItm.children = subCardItm.children?.map((childrenItem) => {
                    let extraConfig = {};
                    switch (childrenItem.key) {
                        case 'email':
                        case 'tel_prefix':
                        case 'tel':
                        case 'restaurant_contact_person':
                        case 'website':
                        case 'discount_info':
                        case 'discount_annual':
                        case 'customer_mark':
                            extraConfig = {
                                disabledInput: useData.componentType === 'PREVIEW',
                                inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            }
                            break;
                        case 'business_labels': {
                            extraConfig = {
                                disabledInput: useData.componentType === 'PREVIEW',
                                inputIsEdited: useData.operateMap.get(`business_labels`) !== undefined ? true : false,
                                multipleProps: {
                                    options: useData.businessLabels,
                                },
                            }
                            break;
                        }
                        case 'belonged_reseller': {
                            extraConfig = {
                                disabledInput: useData.componentType === 'PREVIEW',
                                inputIsEdited: useData.operateMap.get(`belonged_reseller`) !== undefined ? true : false,
                                items: useData.resellerList,
                            }
                            break;
                        }
                        case 'authorization_type':
                            extraConfig = {
                                disabledInput: useData.componentType === 'PREVIEW',
                                inputIsEdited: useData.operateMap.get(`authorization_type`) !== undefined ? true : false,
                                items: useData.authorizationTypes,
                            }
                            break;
                        default:
                            break;
                    }
                    const allowNullVerification = useData.allowNullVerification
                    return {
                        ...childrenItem,
                        ...extraConfig,
                        isEmpty: allowNullVerification,
                        onChange: async (e) => {
                            useData.updateEditRestaurantData(e.target.value, childrenItem.key);
                            // 核心文件日志 2.5餐厅
                            if (useData.componentType !== 'ADD' && 'restaurant_version' && e.target.value === '2.5') {
                                await useData.getCoreFileLog();
                            }
                        },
                        handleMultipleChange: (value) => {
                            return useData.updateEditRestaurantData(value, childrenItem.key);
                        },
                        handleChangeCountry: (value) => {
                            return useData.updateEditRestaurantData(value, childrenItem.key);
                        }
                    }
                })
                return {
                    ...subCardItm
                }
            })
        }
    }) as CardFormConfig[];

    const data = { ...useData.editRestaurantData, avatar: useData.editRestaurantDataAvatar?.src }
    return (
        <div>
            {
                googleMapsApiKey &&
                <LoadGoogleMap
                    googleMapsApiKey={googleMapsApiKey}
                />
            }
            {

                skeleton ?
                    <SkeletonOfRestaurantInfo />
                    :
                    (<CardFrom
                        config={cardConfig}
                        data={data as {}}
                    />)
            }
        </div>
    )
})

/**
 * 骨架屏 - 餐厅详情
 */
const SkeletonOfRestaurantInfo = () => {

    return (
        <div className='skeleton'>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12} className="FCC">
                                    <Skeleton variant='rounded' width={140} height={140} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item container spacing={4}>
                                    <Grid item xs={6}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={80} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item container xs={12} md={6}>
                    <Grid item xs={12}>
                        <CardView
                            style={{ height: '100%' }}
                            contentRender={(
                                <Grid container rowSpacing={4}>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item container spacing={4}>
                                        <Grid item xs={2}>
                                            <Skeleton variant='rounded' height={30} animation='wave' />
                                        </Grid>
                                        <Grid item xs={10}>
                                            <Skeleton variant='rounded' height={30} animation='wave' />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                </Grid>
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CardView
                            style={{ height: '100%' }}
                            contentRender={(
                                <Grid container rowSpacing={4}>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={90} animation='wave' />
                                    </Grid>
                                </Grid>
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                {/* <Grid item xs={12} sx={{ direction: 'rtl' }}>
                                                <Skeleton variant='rounded' width={30} height={30} animation='wave' />
                                            </Grid> */}
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={170} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </div>
    )
}